<template>
  <Navbar />
  <ThemeSelector is-in-app />
  <div class="spinner-container" :class="{'d-none': !loading}"></div>
  <div :class="[{'d-none': loading, 'app--fade-in': !loading}]">
    <router-view />
  </div>

  <AppFooter />
</template>

<script setup lang="ts">
import ThemeSelector from '@/components/ThemeSelector.vue';
import Navbar from './components/Navbar.vue';
import AppFooter from './components/AppFooter.vue';
import {onMounted, ref} from 'vue';

const loading = ref(true);

onMounted(() => {
  setTimeout(() => {
    loading.value = false;
  }, 50);
});
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.spinner-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.app--fade-in {
  margin-top: 120px;
  animation: fadein 4s;
}
</style>
